/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.skills.ProcessSkillCommand
*/
export var ProcessSkillCommand;
(function (ProcessSkillCommand) {
    ProcessSkillCommand["ACTIVATE"] = "ACTIVATE";
    ProcessSkillCommand["CLEAR"] = "CLEAR";
    ProcessSkillCommand["CLEAR_ALL"] = "CLEAR_ALL";
    ProcessSkillCommand["LIST"] = "LIST";
})(ProcessSkillCommand || (ProcessSkillCommand = {}));
//# sourceMappingURL=ProcessSkillCommand.js.map